import { Placeholder } from "@tiptap/extension-placeholder";
import { Underline } from "@tiptap/extension-underline";
import { StarterKit } from "@tiptap/starter-kit";
import CustomImage from "./Extensions/CustomImage";
import Collaborative from "./Extensions/Collaborative";
import { Dropcursor } from "@tiptap/extension-dropcursor";
import { Strike } from "@tiptap/extension-strike";
import { Subscript } from "@tiptap/extension-subscript";
import { Superscript } from "@tiptap/extension-superscript";
export const useExtensions = () => {
  const extensions = [
    StarterKit.configure({ dropcursor: false, strike: false }),
    Underline,
    Dropcursor,
    CustomImage.configure({
      HTMLAttributes: { class: "image-custom-class" },
    }),
    Placeholder.configure({
      placeholder: "Jot a note, a few words, or the beginning of a chapter...",
    }),
    Collaborative,
    Strike,
    Subscript,
    Superscript,
  ];

  return { extensions };
};
